<template>
  <stage-card
    :progress="progress"
    progress-pending-label="Awaiting Screened References"
  >
    <template #header>Full Text Review</template>
    <template #content>
      <full-text-review-progress-and-results :review="review" />
      <div>
        <screening-remaining-tasks-list
          title="Remaining Review Tasks"
          vote-task-label="References you can review"
          :progress-summary="progressSummary"
        />
      </div>
    </template>
    <template #actions>
      <action-button color="primary" @click="$emit('open-workflow')">
        {{ openWorkflowLabel }}
      </action-button>
    </template>
  </stage-card>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import StageCard from './StageCard';
import FullTextReviewProgressAndResults from './FullTextReviewProgressAndResults';
import ScreeningRemainingTasksList from './ScreeningRemainingTasksList';
import { Review } from '@/models';
import { StageCardProgress } from '@/enums';

export default {
  name: 'FullTextReviewStageCard',
  components: {
    ActionButton,
    StageCard,
    FullTextReviewProgressAndResults,
    ScreeningRemainingTasksList,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  emits: ['open-workflow'],
  computed: {
    progress() {
      if (this.review.isFullTextReviewComplete()) {
        return StageCardProgress.COMPLETE;
      }
      if (this.progressSummary.totalReferenceCount() === 0) {
        return StageCardProgress.PENDING;
      }
      return StageCardProgress.IN_PROGRESS;
    },
    progressSummary() {
      return this.review.fullTextReviewScreeningProgressSummary;
    },
    openWorkflowLabel() {
      if (this.review.isFullTextReviewComplete()) {
        return 'View Outcomes';
      }
      return 'Review References';
    },
  },
};
</script>
